import type { Product } from "../Data/catalog";

export type CartItem = Product & {
  quantity: number;
};

const CART_KEY = "cartItems";

export function getCartItems(): CartItem[] {
  const raw = localStorage.getItem(CART_KEY);
  return raw ? JSON.parse(raw) : [];
}

export function saveCartItems(items: CartItem[]) {
  localStorage.setItem(CART_KEY, JSON.stringify(items));
}

export function addToCart(product: Product) {
  const cart = getCartItems();
  const existing = cart.find((item) => item.id === product.id);

  let updated: CartItem[];

  if (existing) {
    updated = cart.map((item) =>
      item.id === product.id
        ? { ...item, quantity: item.quantity + 1 }
        : item
    );
  } else {
    updated = [...cart, { ...product, quantity: 1 }];
  }

  saveCartItems(updated);
  return updated;
}